import AttachmentType from 'owa-service/lib/contract/AttachmentType';

const getAttachmentsForSmimeResponse = (
    parentAttachments: AttachmentType[],
    isForward?: boolean
): AttachmentType[] => {
    if (!parentAttachments || isForward) {
        // All attachments are needed when forward.
        return parentAttachments;
    }

    // Only inline attachments are needed when reply/reply all.
    return parentAttachments.filter(attachment => attachment.IsInline);
};

export default getAttachmentsForSmimeResponse;
